import constants from "../../Utils/constants";
import useTranslator from "../../hooks/useTranslator";
import { useNavigate, useParams } from "react-router-dom";
import { Avatar, Badge, Icon } from "../design";

/** One row of the Payments table: tenant, property, payment status. */
const TenantPaymentList = ({ status, data }) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { workspaceId } = useParams();

  const tenantName = `${data?.tenant_id?.fname ?? ""} ${
    data?.tenant_id?.lname ?? ""
  }`.trim();
  const property = data?.property_id;
  const streetNumber = parseInt(property?.street_number, 10);
  const address = `${property?.street} - ${
    Number.isNaN(streetNumber) ? "N/A" : String(streetNumber)
  }, ${property?.floor_number}-${property?.flat_number}`;

  return (
    <tr
      className="cursor-pointer"
      onClick={() => navigate(`/${workspaceId}/payment/details/${data?._id}`)}
    >
      <td>
        <div className="profile-cell-tenant">
          {tenantName ? (
            <>
              <Avatar name={tenantName} size="sm" />
              <span className="profile-cell-name">{tenantName}</span>
            </>
          ) : (
            <>
              <span className="profile-cell-icon">
                <Icon name="user" size={16} />
              </span>
              <span className="payments-table__muted">-</span>
            </>
          )}
        </div>
      </td>
      <td>{address}</td>
      <td>
        {status === constants.TENANT_PENDING ? (
          <Badge tone="warning">{_t("waitingForTenant")}</Badge>
        ) : (
          status === constants.AWARDED && <Badge>{_t("inPayment")}</Badge>
        )}
      </td>
      <td>
        <span className="profile-row-open">
          <Icon name="chevronRight" size={18} />
        </span>
      </td>
    </tr>
  );
};

export default TenantPaymentList;
